/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiSanctionEntityType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION'
}


export function instanceOfApiSanctionEntityType(value: any): boolean {
    for (const key in ApiSanctionEntityType) {
        if (Object.prototype.hasOwnProperty.call(ApiSanctionEntityType, key)) {
            if (ApiSanctionEntityType[key as keyof typeof ApiSanctionEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiSanctionEntityTypeFromJSON(json: any): ApiSanctionEntityType {
    return ApiSanctionEntityTypeFromJSONTyped(json, false);
}

export function ApiSanctionEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionEntityType {
    return json as ApiSanctionEntityType;
}

export function ApiSanctionEntityTypeToJSON(value?: ApiSanctionEntityType | null): any {
    return value as any;
}

export function ApiSanctionEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiSanctionEntityType {
    return value as ApiSanctionEntityType;
}

